"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupDirectDebitForm = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var analytics_subjects_1 = require("../../../../../analytics-subjects");
var components_2 = require("../../../../../components");
var copy_1 = require("../../../../../copy");
var utils_1 = require("../../../../../utils");
var Fields_1 = require("./Fields");
var SetupDirectDebitForm = function (_a) {
    var _b, _c, _d;
    var defaultValues = _a.values, handleReview = _a.handleReview;
    var _e = __read((0, react_1.useState)(defaultValues), 2), values = _e[0], setValues = _e[1];
    var _f = __read((0, react_1.useState)([]), 2), errors = _f[0], setErrors = _f[1];
    var _g = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _g.copy, Copy = _g.Copy;
    var copyMap = {
        noAmount: copy('setupDirectDebitErrorNoAmount'),
        invalidAmount: copy('setupDirectDebitErrorInvalidAmount'),
        rangeAmount: copy('setupDirectDebitErrorRangeAmount'),
        givenName: copy('setupDirectDebitErrorGivenName'),
        familyName: copy('setupDirectDebitErrorFamilyName'),
        noAccountNumber: copy('setupDirectDebitErrorNoAccountNumber'),
        invalidAccountNumber: copy('setupDirectDebitErrorInvalidAccountNumber'),
        accountNumberLength: copy('setupDirectDebitErrorAccountNumberLength'),
        noSortCode: copy('setupDirectDebitErrorNoSortCode'),
        invalidSortCode: copy('setupDirectDebitErrorInvalidSortCode'),
        sortCodeLength: copy('setupDirectDebitErrorSortCodeLength'),
        bankAuthorised: copy('setupDirectDebitErrorBankAuthorised'),
        ddGuarantee: copy('setupDirectDebitErrorDdGuarantee'),
    };
    var handleDateChange = function (_a) {
        var value = _a.currentTarget.value;
        setValues(__assign(__assign({}, values), { dayOfMonth: Number(value) }));
    };
    var handleInputChange = function (_a) {
        var _b;
        var _c = _a.currentTarget, id = _c.id, value = _c.value;
        setValues(__assign(__assign({}, values), (_b = {}, _b[id] = value, _b)));
    };
    var handleCheckboxChange = function (_a) {
        var _b;
        var _c = _a.currentTarget, id = _c.id, checked = _c.checked;
        setValues(__assign(__assign({}, values), (_b = {}, _b[id] = checked, _b)));
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        setErrors([]);
        var newErrors = (0, utils_1.validate)(values, copyMap);
        if (newErrors.length === 0) {
            handleReview(values);
        }
        else {
            setErrors(newErrors);
        }
    };
    var _h = (0, core_1.useComponents)(), ErrorSummaryNotification = _h.ErrorSummaryNotification, CurrencyField = _h.CurrencyField, PrimaryCTAButton = _h.PrimaryCTAButton, TextField = _h.TextField, SelectField = _h.SelectField, Card = _h.Card, Stack = _h.Stack, Row = _h.Row, Col = _h.Col, Heading1 = _h.Heading1, ButtonGroup = _h.ButtonGroup, Margin = _h.Margin;
    var payments = (0, core_1.useLinks)().payments;
    var retailer = core_1.configService.getConfig().retailer;
    var currencyCode = (0, utils_1.getCurrency)(retailer.currencyCode).code;
    return (react_1.default.createElement(ui_tools_1.AnalyticsView, { name: analytics_subjects_1.SETUP_DD, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement("div", null,
            react_1.default.createElement(ErrorSummaryNotification, { id: "error-summary", errors: errors }),
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
                    react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SETUP_DD_CANCEL, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                        react_1.default.createElement(components_1.Breadcrumb, { "data-testid": "breadcrumb", href: payments() },
                            react_1.default.createElement(Copy, { copyKey: "backtoPaymentsBreadcrumb" }))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(Heading1, null,
                            react_1.default.createElement(Copy, { copyKey: "setupDirectDebitHeading" })),
                        react_1.default.createElement(Copy, { copyKey: "setupDirectDebitBody" })),
                    react_1.default.createElement(Stack, { spaceBetween: 6, as: "form", onSubmit: handleSubmit, method: "POST", noValidate: true, "data-testid": "setup-dd-form" },
                        react_1.default.createElement(SelectField, { label: copy('setupDirectDebitPaymentDateLabel'), id: "dayOfMonth", value: values.dayOfMonth, characters: 8, onChange: handleDateChange },
                            react_1.default.createElement(components_2.DateSelectOptions, null)),
                        react_1.default.createElement(CurrencyField, { id: "amount", label: copy('setupDirectDebitAmountLabel'), value: values.amount, onChange: handleInputChange, min: 1, max: 2000, characters: 8, error: (0, nebula_1.getErrorMessage)('amount', errors), currency: currencyCode }),
                        react_1.default.createElement(TextField, { id: "givenName", label: copy('setupDirectDebitGivenNameLabel'), value: values.givenName, onChange: handleInputChange, error: (0, nebula_1.getErrorMessage)('givenName', errors) }),
                        react_1.default.createElement(TextField, { id: "familyName", label: copy('setupDirectDebitFamilyNameLabel'), value: values.familyName, onChange: handleInputChange, error: (0, nebula_1.getErrorMessage)('familyName', errors) }),
                        react_1.default.createElement(TextField, { id: "accountNumber", label: copy('setupDirectDebitAccountNumberLabel'), value: values.accountNumber, onChange: handleInputChange, error: (0, nebula_1.getErrorMessage)('accountNumber', errors), characters: 8 }),
                        react_1.default.createElement(TextField, { id: "sortCode", label: copy('setupDirectDebitSortCodeLabel'), value: values.sortCode, onChange: handleInputChange, error: (0, nebula_1.getErrorMessage)('sortCode', errors), characters: 8 }),
                        react_1.default.createElement(Row, { isNested: true },
                            react_1.default.createElement(Col, { medium: 10 },
                                react_1.default.createElement(Margin, { top: [2, 4] },
                                    react_1.default.createElement(Fields_1.BankAuthorised, { value: values.bankAuthorised, handler: handleCheckboxChange, error: (0, nebula_1.getErrorMessage)('bankAuthorised', errors) })))),
                        react_1.default.createElement(Fields_1.DirectDebitGuarantee, { value: values.ddGuaranteeAccepted, handler: handleCheckboxChange, error: (0, nebula_1.getErrorMessage)('ddGuaranteeAccepted', errors) }),
                        react_1.default.createElement(ButtonGroup, null,
                            react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.SETUP_DD_SUBMIT, properties: (_d = {}, _d[core_1.INTERNAL_EVENT_FLAG] = true, _d) },
                                react_1.default.createElement(PrimaryCTAButton, { "data-testid": "submit-setup-dd", type: "submit" },
                                    react_1.default.createElement(Copy, { copyKey: "setupDirectDebitSubmit" }))))),
                    react_1.default.createElement(Fields_1.GoCardless, null))))));
};
exports.SetupDirectDebitForm = SetupDirectDebitForm;
